import { Injectable, inject } from "@angular/core";
import {Store} from "@ngrx/store";
import {ActivatedRouteSnapshot, Router, UrlTree} from "@angular/router";
import {Observable, withLatestFrom} from 'rxjs';
import {map} from "rxjs/operators";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

@Injectable({
  providedIn: 'root'
})
export class TeamAppLoginGuard {
  private store = inject(Store);
  private router = inject(Router);


  canActivate(state: ActivatedRouteSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.select(SharedLoginSelectors.selectToken).pipe(
      withLatestFrom(this.store.select(SharedLoginSelectors.selectTenant)),
      map(([token, tenant]) => {
        const hasToken = !!token?.refreshToken;
        const hasTenant = !!tenant;
        const isGuest = token?.info?.isGuest ?? false;

        if (isGuest) {
          return this.router.createUrlTree(['team/welcome']);
        } else if (hasToken && !hasTenant) {
          return this.router.createUrlTree(['team/welcome']);
        } else if (hasToken && hasTenant) {
          return true;
        } else {
          return this.router.createUrlTree(['team/login'], {
            queryParams: {
              redirect: `${ window.location.href }`
            }
          });
        }
      })
    );
  }

}
